module.exports = __webpack_public_path__ + "img/face_shape_male_heart_mask.4f02ab75.png";